<template>
  <div class="step-section">
    <div class="step-container">
      <h2 class="step-title">
        {{ $store.state.bookingSteps.stepsData.step1.title }}
      </h2>

      <div v-if="loading" class="loading-grid">
        <div v-for="index in 16" :key="index" class="skeleton-item">
          <div class="skeleton-loader"></div>
        </div>
      </div>

      <div v-else class="specialities-grid">
        <button
          v-for="(speciality, index) in specialities"
          :key="speciality.id"
          class="speciality-card"
          :class="{ 'speciality-card--active': selected === index }"
          type="button"
          @click="selectSpeciality(index)"
        >
          <div class="speciality-media">
            <img :src="speciality.image_url" :alt="speciality.name" />
          </div>
          <h5>{{ speciality.name }}</h5>
        </button>
      </div>
    </div>

    <steps-nav
      :cancel-button-label="
        $store.state.bookingSteps.stepsData.cancelButtonLabel
      "
      :next-button-label="$store.state.bookingSteps.stepsData.nextButtonLabel"
      :can-proceed="selected !== null"
      @cancel="$emit('cancel')"
      @next="nextStep"
    />
  </div>
</template>

<script>
import API from "@/api/dynamicAPI";
import StepsNav from "../StepsNav";
export default {
  name: "step1",
  components: {
    StepsNav,
  },
  data() {
    return {
      selected: null,
      specialities: [],
      loading: false,
    };
  },
  async mounted() {
    this.loading = true;
    try {
      if (
        this.$store.state.bookingSteps.stepsData.step1.request.type === "get"
      ) {
        const res = await API.getAPI(
          this.$store.state.bookingSteps.stepsData.step1.request,
          this.$store.state.bookingSteps.stepsData.step1.request.headers
        );
        this.specialities = res && res.data ? res.data.data : [];
      } else if (
        this.$store.state.bookingSteps.stepsData.step1.request.type === "post"
      ) {
        const res = await API.postAPI(
          this.$store.state.bookingSteps.stepsData.step1.request,
          this.$store.state.bookingSteps.stepsData.step1.request.headers
        );
        this.specialities = res && res.data ? res.data.data : [];
      }
    } catch (e) {
      console.log(e);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    selectSpeciality(index) {
      this.selected = index;
      this.nextStep();
    },
    nextStep() {
      if (this.selected === null || !this.specialities[this.selected]) return;

      this.$store.state.bookingSteps.selectedStepsData[
        this.$store.state.bookingSteps.stepsData.step1.selectedNameAttribute
      ] = this.specialities[this.selected].name;
      this.$store.state.bookingSteps.selectedStepsData[
        this.$store.state.bookingSteps.stepsData.step1.selectedIdAttribute
      ] = this.specialities[this.selected].id;
      this.$emit("nextStep");
    },
  },
};
</script>

<style lang="scss" scoped>
.step-section {
  padding-bottom: 12px;
}

.step-container {
  padding: 8px 28px 0;
}

.step-title {
  margin-bottom: 18px;
  color: var(--main-color);
  font-size: 24px;
  font-weight: 800;
  line-height: 1.2;
}

.loading-grid,
.specialities-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 14px;
}

.skeleton-loader {
  height: 168px;
  border-radius: 22px;
  background: linear-gradient(90deg, #eef2f7 25%, #f8fafc 50%, #eef2f7 75%);
  background-size: 200% 100%;
  animation: shimmer 1.3s infinite linear;
}

.speciality-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 168px;
  padding: 18px 14px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 22px;
  background: #fff;
  text-align: center;
  transition: all 0.22s ease;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.05);
}

.speciality-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 18px 34px rgba(15, 23, 42, 0.08);
}

.speciality-media {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  margin-bottom: 14px;
  border-radius: 18px;
  background: rgba(248, 250, 252, 0.9);
}

.speciality-media img {
  width: 58px;
  height: 58px;
  object-fit: contain;
}

.speciality-card h5 {
  margin: 0;
  color: #0f172a;
  font-size: 14px;
  font-weight: 800;
  text-transform: uppercase;
}

.speciality-card--active {
  border-color: transparent;
  background: linear-gradient(
    180deg,
    var(--main-color),
    var(--secondary-color)
  );
}

.speciality-card--active h5 {
  color: #fff;
}

.speciality-card--active .speciality-media {
  background: rgba(255, 255, 255, 0.16);
}

.speciality-card--active .speciality-media img {
  filter: brightness(0) invert(1);
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

@media (max-width: 959px) {
  .step-container {
    padding: 8px 16px 0;
  }

  .step-title {
    font-size: 20px;
  }

  .loading-grid,
  .specialities-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }

  .speciality-card {
    min-height: 150px;
  }
}
</style>
